module.exports = __webpack_public_path__ + "media/img/partners/citiworld-logo-f5366539068817cec8b018e50ee6a22e.png";